<template>
  <modal
    class="suspendedModal"
    name="suspendedModal"
    transition="pop-out"
    :clickToClose="false"
  >
    <div class="suspended_modal row">
      <div class="col-md-3 suspended_emoji">
        <img src="@/assets/img/dissapointment.svg" />
      </div>
      <div class="col-md-9 epump_sub_content">
        <p class="epump_sub">
          <span class="dear_span">{{ $t("text.dModal.dearCustomer") }}</span>
          {{ $t("text.dModal.accessDisabled") }}
        </p>
        <div
          class="mt-4 epump_payment"
          v-if="
            this.$route.name == 'IndustrialBranchDashboard' ||
            this.$route.name == 'industrial_group_dashboard'
          "
        >
          <p class="epump_sub font-weight-bold">
            {{ $t("text.cMasterLayout.contactCom") }}
          </p>
          <button class="payment_button float-right mt-3" @click="signOutUser">
            {{ $t("text.cMasterLayout.logOut") }}
          </button>
        </div>
        <div class="epump_payment" v-else>
          <button class="payment_button float-right mt-3" @click="signOutUser">
            {{ $t("text.cMasterLayout.logOut") }}
          </button>
          <!-- <button class="payment_button">Make payment now</button> -->
          <!-- <router-link
            :to="{
              name: branch
                ? 'branch_invoice'
                : industry
                ? 'industrial_admin_invoice'
                : 'company_invoice',
              query:
                branch && this.$route.query.branchId
                  ? { branchId: this.$route.query.branchId }
                  : industry && this.$route.query.companyID
                  ? { companyID: this.$route.query.companyID }
                  : null,
            }"
            class="view_invoices_text"
            v-show="
              $route.name !== 'company_invoice' &&
              $route.name !== 'branch_invoice' &&
              $route.name !== 'industrial_admin_invoice'
            "
          >
            <div class="payment_button">
              {{ $t("text.dModal.viewInvoices") }}
            </div>
          </router-link> -->
          <!-- <button
            class="payment_button"
            v-show="
              $route.name == 'company_invoice' ||
              $route.name == 'branch_invoice' ||
              $route.name == 'industrial_admin_invoice'
            "
            @click="closeModal"
          >
            {{ $t("text.dModal.viewInvoices") }}
          </button> -->
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import configObject from "@/config";
import JQuery from "jquery";
let $ = JQuery;

const MODAL_WIDTH = 980;
// const MODAL_WIDTH = 1340;

export default {
  name: "suspendedModal",
  props: ["statusInfo", "branch", "industry"],
  data() {
    return {
      modalWidth: MODAL_WIDTH,
      isButtonDisabled: false,
      modalDataValues: {},
      pumpName: "",
    };
  },
  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },
  methods: {
    closeModal() {
      this.$modal.hide("suspendedModal");
    },
    signOutUser() {
      const answer = window.confirm(
        this.$t("text.cMasterLayout.confirmLogout"),
      );
      if (answer) {
        if (localStorage.getItem("locale")) {
          const locale = localStorage.getItem("locale");
          this.$store.commit("setBaseLocale", locale);
        }
        this.$store.commit("setModalShown", false);
        this.$store.commit("setStatusInfo", {});
        this.$store.commit("setBranchModalShown", false);
        this.$store.commit("setBranchStatusInfo", {});

        this.$store.dispatch("logout");
      }
    },
  },
};
</script>
